import React, { useState, useEffect, useContext } from "react";

import Modal from "calcite-react/Modal";
import Button from "calcite-react/Button";
import { CalciteP, CalciteH2 } from "calcite-react/Elements";
import "./AppLaunchModal.css";

import { MapContext } from "contexts/MapContext";

const AppLaunchModal = () => {
  const { showAppLaunchModal, setShowAppLaunchModal } = useContext(MapContext);
  return (
    <Modal open={showAppLaunchModal} contentStyles={{ padding: "2em" }}>
      <h3 slot='header'>We’re moving!</h3>
      <p slot='content'>
        We’re moving! Starting <strong>May 22, 2024</strong>, the DETOUR Ohio Trails app will{" "}
        <strong>no longer be supported</strong>. For a new and improved way to access information about Ohio’s state
        parks, trails, and more, download the new <strong>Ohio trails and outdoor app</strong>, officially launching on
        <strong> May 22, 2024!</strong>
      </p>
      <p slot='content' style={{ display: "grid", justifyContent: "flex-end" }}>
        {" "}
        <Button
          onClick={() => {
            console.log("clicked");
            setShowAppLaunchModal(false);
          }}
        >
          OK
        </Button>
      </p>
    </Modal>
  );
};

export default AppLaunchModal;
